/**
 * @license
 * Copyright 2018 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import './lasso.less';
import './common_style.less'
import { SliceViewPanel } from 'neuroglancer/sliceview/panel';
import { message } from '../widget/message';
import { RefCounted } from 'neuroglancer/util/disposable';
import {
  Viewer,
  isToolControl,
  isSelectView,
  disableStatus,
  SwitchV2Info
} from 'neuroglancer/viewer';
import { makeElement } from '../ui/layer_gene_table_tab';
import { ConfigIndependDialog } from '../ui/congfig-dialog';
import { allToolsButton, getWorkflowParam, local_host_SN_flag, _param as local_href_param, viewer } from 'src/main';
import { cancellableFetchSpecialOk } from '../util/special_protocol_request';
import { responseJson } from '../util/http_request';
import { SelectView } from '../widget/select_view';
import { WatchableValue } from 'neuroglancer/trackable_value';
import svg_edit from 'neuroglancer/static/lasso_edit.svg';
// import svg_save from 'neuroglancer/static/lasso_save.svg';
import svg_delete from 'neuroglancer/static/lasso_delete.svg';
import svg_add from 'neuroglancer/static/lasso_add.svg';
import svg_video from 'neuroglancer/static/lasso_video.svg';
import { debounce } from 'lodash';
import { TrackableBoolean } from '../trackable_boolean';
import i18n from '../i18n/i18n';
import { getData } from '../util/comm_fun_hq';
import { registerLassoOpenDialog } from './register_lasso_open_dialog';
import { vec2 } from "gl-matrix";
import { LoadedLayerDataSource } from '../layer_data_source';
import { dbStorageMoreWindow } from 'neuroglancer/util/indexDb';
export let currentActivedTool1: HTMLElement | null = null
// clipper.js的全局变量
let ClipperLib = (<any>window).ClipperLib;
// 特征点半径
const POINT_RADIUS = 7;
// gene选择框, 用于确定弹框位置
let geneSelectDom: any;
// html的字体大小，用于响应式确定距离
let htmlFontSize: number;
// 当前binszie
let binSize: string;
let boundSizePath: any[];
let isLastBin: boolean = false;
let selectBin: string = 'bin100';

// 数字转十六进制
function numToHex(num: number) {
  let res = num.toString(16);
  if (res.length < 2) {
    res = '0' + res;
  }
  return res;
}

// 随机颜色生成函数
function randomColor() {
  var random = Math.random;
  var floor = Math.floor;
  return `#${numToHex(floor(random() * 256))}${numToHex(floor(random() * 256))}${numToHex(floor(random() * 256))}`
}
// canvas的onmouseup事件, 抽出来是因为其他场合会用到
let tempEvent: any;
let domContent = {
  first: '',
  second: '',
}
let labelNameSet = new Set();

export class Lasso extends RefCounted {
  isDuplicate: boolean = false;
  // 主canvas, 用来lasso
  canvas = document.createElement('canvas');
  ctx: CanvasRenderingContext2D | null = this.canvas.getContext('2d');
  // 副本canvas，用于快速选中某个轨迹
  cloneCanvas = document.createElement('canvas');
  cloneCtx: CanvasRenderingContext2D | null = this.cloneCanvas.getContext('2d');
  // 当前SliceViewPanel的element
  sliceViewPanelElement: HTMLElement;
  // 控制第三个弹框情况下不能lasso
  canDraw: boolean = true;
  // 绘制类型，3种：圈选，挖孔，禁止绘制
  drawType: boolean | string = false;
  // 存储所有轨迹
  allPathArr: any[] = [{
    // 轨迹名称, 第一个默认是label1
    name: 'Label1',
    // 存储单个轨迹canvas坐标系坐标
    points: [{
      type: 'yes',
      arr: [],
    }],
    // 轨迹是否被选中
    selected: false
  }];
  // 存储副本canvas上每个轨迹的绘制颜色, 初始化先给个随机颜色
  colorArr: string[] = [randomColor()];
  // 当前选中轨迹index, -1代表未选中
  selectedPathIndex = new WatchableValue(-1);
  // 当前选中特征点
  selectedPoint: { X: number, Y: number } | null;
  // 当前选中特征点对应的ng坐标系的点
  selectedNgPoint: { X: number, Y: number } | null;
  // lable名集合
  labelNameArr: string[] = [];
  // binsize集合
  binsizeArr = allToolsButton.bin_list as string[];
  // 统计信息选择框默认值
  selectedStatistic = '';
  // select lasso选择框默认值
  selectedLasso = '';
  // select binsize选择框默认值
  selectedBinsize = 'bin100,';
  cpr: any = new ClipperLib.Clipper();
  // select选择框是否最后一个选中标志
  isLastSelected: boolean = false;
  isLoading = new TrackableBoolean(false, false);
  lassobin: string[] = [];
  lasso_markergene_param: any = {
    all_jihe: {},
  };
  private sliceViewPanel: SliceViewPanel;
  constructor(public viewer: Viewer, public btn: HTMLElement) {
    super();
    if (viewer.lassoTool) {//lasso单例，挂在viewer上
      this.isDuplicate = true;
      this.dispose();
      return viewer.lassoTool;
    } else {
      viewer.lassoTool = this;
      currentActivedTool1 = btn;
      this.initdom(false);
      binSize = this.viewer.binSize.value as string;
      let { lowerBounds, upperBounds } = this.viewer.coordinateSpace.value.bounds;
      boundSizePath = [{ X: lowerBounds[0], Y: lowerBounds[1] }, {
        X: upperBounds[0],
        Y: lowerBounds[1]
      }, { X: upperBounds[0], Y: upperBounds[1] }, { X: lowerBounds[0], Y: upperBounds[1] }];
      labelNameSet.clear();
      this.isLasso();
      disableStatus(true, undefined, false);
      // 24是ui图上1920尺寸下弹框距离定位元素的距离
      new ConfigIndependDialog(geneSelectDom, this.getFirstInfoContent(), {
        position: 'bottom',
        unique: true,
        className: 'first_info_container',
        offsetCol: htmlFontSize / 16 * 24
      });
      this.selectedPathIndex.changed.add(() => {
        // 选中轨迹且candraw则主canvas不允许穿透，没选中轨迹则主canvas允许穿透
        if (this.selectedPathIndex.value >= 0) {
          this.canvas.style.pointerEvents = 'auto';
        } else {
          this.canvas.style.pointerEvents = 'none';
        }
        // 改变input的样式
        let eleArr = document.querySelectorAll('.can_zoom_move_container_unique .lasso_select li');
        for (let i = 0; i < eleArr.length; i++) {
          if (this.selectedPathIndex.value >= 0 && i == this.selectedPathIndex.value) {
            (<any>eleArr[i]).dataset.checked = 'true';
          } else {
            (<any>eleArr[i]).dataset.checked = 'false';
          }
        }
      })
      // } else {
      //   // 退出lasso
      //   this.exitLasso();
      // }
      this.isLoading.value = false
      // }, time);
      btn.setAttribute('data-checked', 'true');
    }
  }
  loadLassoFile(lassoData: any) {
    let lassoArr = JSON.parse(lassoData.detailJson);
    if (lassoArr.data && lassoArr.data.length) {
      this.initLassoPath(lassoData);
    } else {
      new message(i18n.lassoPanelHoldCtrl + i18n.lassoPanelHoldAlt + i18n.lassoPanelEnterConfrom, 'info', true);
    }
  }
  async exitLasso() {
    new message(i18n.lassoPanelExit, 'info');
    currentActivedTool1 = null;
    this.initdom(true);
    disableStatus(false, undefined, false);
    if (!local_href_param.visible) {
      const obj = {
        href: '',
        value: [[], []]
      }
      if (dbStorageMoreWindow) {
        await dbStorageMoreWindow.update('layerName', { name: 'value', data: obj });
      }
      localStorage.setItem('layerName', new Date().toLocaleString());
    }
    this.btn.setAttribute('data-checked', 'false');
  }
  // dom初始化，包括外部元素和内部元素
  async initdom(bool: boolean) {
    this.removeCanvasAndDialog();
    // 顶部操作按钮(gene, layer, binsize, cluster等)disable控制
    isSelectView(bool);
    // 顶部操作按钮(undo, 手动配准, 配准模板等)disable控制
    isToolControl(bool ? 'remove' : 'add', ['lassoBtn']);
    // isToolControl(bool === 'block' ? true : false, ['lassoBtn', 'neuroglancer-icon-transform']);
    // 手动配准
    let element = document.getElementsByClassName('neuroglancer-icon-transform')[0];
    if (element) {
      if (element.getAttribute('data-checked') === 'true') {
        (element as HTMLElement).classList.remove("disabled");
      } else if (element.getAttribute('data-checked') === 'false' && this.viewer.binSize.value === 'cellbin') {
        element.classList.add("disabled");
      }
    }
    let element_template = document.getElementsByClassName('neuroglancer-icon-standardAnalysis')[0];
    if (element_template && this.viewer.binSize.value === 'cellbin') {
      element_template.classList.add("disabled");
    }
    //  let element1 = document.getElementsByClassName('selected-gene-more-dialog')[0];
    //  element1 && document.body.removeChild(element1);
    let element2 = document.getElementsByClassName('more-details-configdialog')[0];
    element2 && document.body.removeChild(element2);

    // 左侧保存状态，导出高清图按钮等disable控制
    //  let doms2 = document.querySelectorAll('.neuroglancer-viewer-left-row .neuroglancer-icon');
    //  for (let i = 0; i < doms2.length; i++) {
    //    (doms2[i] as HTMLElement).classList[bool ? 'remove' : 'add']("disabled");
    //  }
    let btn = (document.getElementsByClassName('statu-load-div')[0] as HTMLElement);
    if (btn) {
      btn.style.display = bool ? 'flex' : 'none';
    }
    if (document.getElementsByClassName('registration-geo-lod-div')[0]) (document.getElementsByClassName('registration-geo-lod-div')[0] as HTMLElement).style.display = bool ? 'flex' : 'none';//控制导入geojson配准按钮

    if (!bool) {
      geneSelectDom = document.querySelector('.gene-view');
      htmlFontSize = parseInt(getComputedStyle(document.documentElement).fontSize);
      this.canvas.classList.add('lassoCanvas');
      this.cloneCanvas.classList.add('cloneLassoCanvas');
      this.canvas.width = this.cloneCanvas.width = window.innerWidth;
      this.canvas.height = this.cloneCanvas.height = window.innerHeight;
      // 获取sliceViewPanelElement
      for (let value of this.viewer.display.panels.values()) {
        if (value instanceof SliceViewPanel) {
          this.sliceViewPanel = value;
          this.sliceViewPanelElement = value.element;
        }
      }
      // 允许穿透
      this.canvas.style.pointerEvents = 'none';
      if (this.sliceViewPanelElement) {
        this.sliceViewPanelElement.appendChild(this.canvas);
      }
    }
  }

  isLasso() {
    let mouseDownFlag: any = false;
    let enterEvent = debounce(() => {
      this.drawType = false;
      this.enterOperate();
    }, 300)
    // 注册keydown事件
    this.registerEventListener(document, 'keydown', (event: KeyboardEvent) => {
      if (!this.canDraw) return;
      // 不允许穿透
      if (event.code === "ControlLeft") {
        this.drawType = "yes";
        this.canvas.style.pointerEvents = 'auto';
      } else if (event.code === "AltLeft") {
        this.drawType = "no";
        this.canvas.style.pointerEvents = 'auto';
      } else if ((event.code === 'Enter' || event.code === 'NumpadEnter') && !event.ctrlKey && !event.altKey) {
        enterEvent();
      }
    })
    this.registerDisposer(this.sliceViewPanel.sliceView.projectionParameters.changed.add(() => {
      this.draw();
    }));
    // 注册keyup事件
    this.registerEventListener(document, 'keyup', () => {
      // keyup但mousedown情形
      tempEvent();
      this.canvas.style.pointerEvents = 'auto';
      this.drawType = false;
    })
    // 当主canvas允许穿透时, 通过sliceViewPanelElement的dblclick事件来选中轨迹
    this.registerEventListener(this.sliceViewPanelElement, 'dblclick', (e: any) => {
      if (this.canDraw) {
        // if (e.button === 0) {
        this.pathSelect(e, -1);
        // }
      }
    });
    // 注册mousedown事件，执行绘制开始操作或者新增特征点操作或者选中特征点操作
    this.canvas.onmousedown = (e) => {
      if (this.canDraw) {
        if (this.drawType) {
          // 执行绘制开始操作
          mouseDownFlag = true;
          // 如果当前选中轨迹，则在选中轨迹基础上操作，否则就是在最后一个轨迹基础上操作
          let index = this.selectedPathIndex.value >= 0 ? this.selectedPathIndex.value : this.allPathArr.length - 1;
          let points = this.allPathArr[index].points;
          let arr = this.unProject([e.clientX, e.clientY])
          if (!points[0].arr.length) {
            points[0].arr.push([{ X: arr[0], Y: arr[1] }]);
            points[0].type = this.drawType;
          } else {
            points.push({ type: this.drawType, arr: [{ X: arr[0], Y: arr[1] }] });
          }
        } else {
          console.log(e.button);
          if (e.button === 2) {
            if (this.selectedPathIndex.value >= 0) {
              // 执行新增特征点或选中特征点操作
              const x = e.clientX;
              const y = e.clientY;

              let ngPoint = this.unProject([x, y])
              this.selectedPoint = this.findSelectedPoint(x, y);
              console.log(this.selectedPoint);
              if (!this.selectedPoint) {
                this.addPoint(ngPoint[0], ngPoint[1]);
              }
            }
            // } else if (e.button === 0) {
            //   this.pathSelect(e, -1)
          }
        }
      }
      e.stopPropagation();
    }
    // 双击选中轨迹或取消选中轨迹
    this.canvas.ondblclick = (e) => {
      this.pathSelect(e, -1);
      e.stopPropagation();
    }
    // 在canvas上mousewheel能触发sliceViewPanelElement的zoom-via-wheel事件
    (<any>this.canvas).onmousewheel = (e: any) => {
      if (this.drawType || mouseDownFlag) return;
      const actionEvent = new CustomEvent('action:zoom-via-wheel', {
        'bubbles': true,
        detail: e,
        cancelable: true
      });
      this.sliceViewPanelElement.dispatchEvent(actionEvent);
    }
    // 注册mousemove事件，执行绘制操作或者拖动特征点操作
    this.canvas.onmousemove = (e) => {
      if (this.canDraw) {
        if (this.drawType) {
          if (mouseDownFlag) {
            // 执行绘制操作
            // 如果当前选中轨迹，则在选中轨迹基础上操作，否则就是在最后一个轨迹基础上操作
            let index = this.selectedPathIndex.value >= 0 ? this.selectedPathIndex.value : this.allPathArr.length - 1;
            let arr = this.unProject([e.clientX, e.clientY])
            let points = this.allPathArr[index].points;
            if (points.length == 2) {
              points[1].arr.push({ X: arr[0], Y: arr[1] });
            } else {
              points[0].arr[0].push({ X: arr[0], Y: arr[1] });
            }
            this.draw();
          }
        } else {
          // 执行拖动特征点操作
          if (this.selectedPoint) {
            this.selectedPoint.X = e.clientX;
            this.selectedPoint.Y = e.clientY;
            let ngPoint = this.unProject([e.clientX, e.clientY])
            // if (document.querySelector(".second_info_container")) {
            // 如果第二个dialog存在，才同时改变ng坐标系里的坐标
            // 同时改变ng坐标系里的坐标
            this.selectedNgPoint!.X = ngPoint[0];
            this.selectedNgPoint!.Y = ngPoint[1];
            // }
            this.draw();
          }
        }
      }
    }
    tempEvent = () => {
      if (mouseDownFlag) {
        mouseDownFlag = false;
        // 如果当前选中轨迹，则在选中轨迹基础上操作，否则就是在最后一个轨迹基础上操作
        let index = this.selectedPathIndex.value >= 0 ? this.selectedPathIndex.value : this.allPathArr.length - 1;
        let { points } = this.allPathArr[index];
        // 如果用户是直接挖孔，则清空
        if (points.length === 1 && points[0].type === "no") {
          points[0].type = 'yes';
          points[0].arr.length = 0;
          this.draw();
          return;
        }
        // 先减点canvas坐标系坐标
        if (points.length === 2) {
          // 如果不是顺时针绘制，则倒置一下
          if (!this.isClockwise(points[1].arr)) {
            points[1].arr.reverse();
          }
          points[1].arr = this.simplify(points[1].arr);
        } else {
          // 如果不是顺时针绘制，则倒置一下
          if (!this.isClockwise(points[0].arr[0])) {
            points[0].arr[0].reverse();
          }
          // 和boundsize做一次交集操作，主要是防止第一次绘制的时候自相交的情况
          points[0].arr = this.cprExecute(points[0].arr, boundSizePath, ClipperLib.ClipType.ctIntersection);
          points[0].arr[0] = this.simplify(points[0].arr[0]);
        }
        // 处理绘制小于3个点情况
        if ((points.length === 1 && points[0].arr[0].length < 3) || (points.length === 2 && points[1].arr.length < 3)) {
          new message(i18n.lassoPanelLess3, 'error');
          if (points.length == 2) {
            points.pop();
          } else {
            // 清空
            points[0].type = 'yes';
            points[0].arr.length = 0;
          }
          this.draw();
          return;
        }
        // lasso完之后如果当前没有选中路径，则选中最后一个路径
        if (this.selectedPathIndex.value < 0) {
          this.selectedPathIndex.value = this.allPathArr.length - 1;
          this.allPathArr[this.selectedPathIndex.value].selected = true;
          let second_info_container = document.querySelector(".second_info_container");
          if (second_info_container) {
            let lastLi: any = second_info_container.querySelector(".lasso_select li:last-child");
            lastLi.dataset.checked = true;
          }
        }
        if (points.length === 2) {
          // 数组长度为2则执行轨迹布尔操作
          let clipType = points[1].type === "no" ? ClipperLib.ClipType.ctDifference : ClipperLib.ClipType.ctUnion;
          points[0].arr = this.cprExecute(points[0].arr, points[1].arr, clipType);
          points.length = 1;
        }
        // 绘制
        this.draw();
        console.log(this.allPathArr);
      }
    }
    // 注册mouseout事件，执行绘制完毕操作
    this.canvas.onmouseout = () => {
      if (this.drawType && this.canDraw) {
        tempEvent();
      }
    }
    // 注册mouseup事件，执行绘制完毕操作或者取消选中特征点操作
    this.canvas.onmouseup = () => {
      if (this.canDraw) {
        if (this.drawType) {
          tempEvent();
        } else {
          this.selectedPoint = null;
        }
      }
    }
  }

  initLassoPath(lassoData: any) {
    let lassoArr = JSON.parse(lassoData.detailJson);
    this.viewer.position.restoreState(lassoArr.center);
    this.viewer.crossSectionScale.value = lassoArr.scale;
    let ngPoints = lassoArr.data;
    if (Array.isArray(lassoArr.data[0])) {
      // 旧数据
      let points: any[] = [];
      ngPoints.forEach((path: any, index: number) => {
        points.push([]);
        path.forEach((item: any) => {
          points[index].push({ X: item[0], Y: item[1] });
        })
      })
      // 兼容老数据，进行减点操作
      points.forEach((path: any, index: number) => {
        // // 如果不是顺时针绘制，则倒置一下
        // if (!this.isClockwise(path)) {
        //   path.reverse();
        // }
        points[index] = this.simplify(path);
      })
      this.allPathArr[0].points[0].arr = points;
      this.allPathArr[0].name = lassoData.label;
    } else {
      // 新数据
      this.allPathArr = ngPoints;
      if (ngPoints.length > 1) {
        for (let i = 1; i < ngPoints.length; i++) {
          while (true) {
            let color = randomColor();
            if (!this.colorArr.includes(color)) {
              this.colorArr.push(color);
              break;
            }
          }
        }
      }
    }
    this.selectedPathIndex.value = this.allPathArr.length - 1;
    // 绘制
    this.draw();
  }

  draw() {
    // 主canvas和副本canvas都绘制
    let ctxArr = [this.ctx, this.cloneCtx];
    ctxArr.forEach((item: CanvasRenderingContext2D) => {
      // 先清空画布
      item.clearRect(0, 0, this.canvas.width, this.canvas.height);
      // 轮询每个轨迹
      for (let i1 = 0; i1 < this.allPathArr.length; i1++) {
        let points = this.allPathArr[i1].points;
        // 在lasso的时候，points的长度可能为2，一般为1
        for (let i2 = 0; i2 < points.length; i2++) {
          item.beginPath();
          // points[0]
          if (i2 === 0) {
            // points[0].arr可能为多个路径，所以要轮询
            for (let i3 = 0; i3 < points[0].arr.length; i3++) {
              for (let i4 = 0; i4 < points[0].arr[i3].length; i4++) {
                const screenPoint = this.project([points[0].arr[i3][i4].X, points[0].arr[i3][i4].Y])
                if (!i4) item.moveTo(screenPoint[0], screenPoint[1]);
                else item.lineTo(screenPoint[0], screenPoint[1]);
              }
              item.closePath();
            }
          } else {
            // points[1].arr为单个路径
            const fistScreenPoint = this.project([points[i2].arr[0].X, points[i2].arr[0].Y])
            item.moveTo(fistScreenPoint[0], fistScreenPoint[1]);
            for (let i5 = 1; i5 < points[i2].arr.length; i5++) {
              const lineScreenPoint = this.project([points[i2].arr[i5].X, points[i2].arr[i5].Y])
              item.lineTo(lineScreenPoint[0], lineScreenPoint[1]);
            }
            item.closePath();
          }
          // 主canvas填充颜色为绿色和白色
          if (item === this.ctx) {
            if (this.allPathArr[i1].selected) {
              item.lineWidth = 5;
              item.strokeStyle = '#fff';
              item.fillStyle = "rgba(202, 249, 130, 0.5)";
            } else {
              item.lineWidth = 1;
              item.strokeStyle = '#000';
              if (points[i2].type === "yes") {
                item.fillStyle = "rgba(0, 128, 0, 0.5)";
              } else if (points[i2].type === "no") {
                item.fillStyle = "rgba(255, 255, 255, 0.5)";
              }
            }
            item.setLineDash([5, 4, 3]);
            item.lineDashOffset = 0;
          } else {
            // 副本canvas描边和填充颜色为随机色
            item.fillStyle = item.strokeStyle = this.colorArr[i1];
          }
          item.stroke();
          item.fill();
        }
      }
    })
    if (this.selectedPathIndex.value >= 0) {
      let arr = this.allPathArr[this.selectedPathIndex.value].points[0].arr;
      this.drawPointWithArr(arr);
    }
  }

  // 移除套索canvas和面板
  removeCanvasAndDialog() {
    let ele1 = document.getElementsByClassName('lassoCanvas')[0];
    ele1 && ele1.parentElement?.removeChild(ele1);
    let ele2 = document.getElementsByClassName('can_zoom_move_container_unique')[0];
    ele2 && ele2.parentElement?.removeChild(ele2);
    let ele3 = document.getElementsByClassName('cloneLassoCanvas')[0];
    ele3 && ele3.parentElement?.removeChild(ele3);
    let ele4 = document.getElementsByClassName('can_zoom_move_container')[0];
    ele4 && ele4.parentElement?.removeChild(ele4);
  }

  unProject(screenCoor: number[]) {
    const projectionParameters = this.sliceViewPanel.sliceView.projectionParameters.value
    let coordinate_NDC = vec2.fromValues(2 * screenCoor[0] / projectionParameters.width - 1, 1 - 2 * screenCoor[1] / projectionParameters.height);
    vec2.transformMat4(coordinate_NDC, coordinate_NDC, this.sliceViewPanel.sliceView.projectionParameters.value.invViewProjectionMat);
    return [Math.floor(coordinate_NDC[0]), Math.floor(coordinate_NDC[1])];
  }

  project(arr: number[]) {
    const projectionParameters = this.sliceViewPanel.sliceView.projectionParameters.value
    let screenCoor = vec2.fromValues(arr[0], arr[1]);
    vec2.transformMat4(screenCoor, screenCoor, projectionParameters.viewProjectionMat);
    return [(1 + screenCoor[0]) * projectionParameters.width / 2, projectionParameters.height - (1 + screenCoor[1]) * projectionParameters.height / 2];
  }

  // 获取初始弹框内容
  getFirstInfoContent() {
    const div = makeElement('div', ['info_content']);
    const p = makeElement('p', [], {}, i18n.lasso);
    div.appendChild(p);
    const ul = makeElement('ul');
    let arr = [i18n.lassoPanelHoldCtrl, i18n.lassoPanelHoldAlt, i18n.lassoPanelRightClick, i18n.lassoPanelEnterConfrom, i18n.lassoPanelDBClick];
    arr.forEach((item) => {
      let li = makeElement('li', [], {}, item);
      ul.appendChild(li);
    })
    div.appendChild(ul);
    return div;
  }

  // 获取第二个弹框内容
  getSecondInfoContent(type?: string) {
    const div = makeElement('div', ['lasso__container']);
    const p = makeElement('p', [], {}, i18n.lasso);
    div.appendChild(p);

    let ele = this.getLassoSelctContent();
    ele && div.appendChild(ele);

    const buttonGroup = makeElement('div', ['button__group']);
    buttonGroup.innerHTML = `
        <div class='lasso_add'>
          <i>${svg_add}</i>${i18n.lassoPanelAdd}
        </div>
        <div class='lasso_run'>
          <i>${svg_video}</i>${i18n.lassoPanelRun}
        </div>
      `;
    div.appendChild(buttonGroup);

    const p2 = makeElement('p', [], {}, i18n.clustering_parameter);
    div.appendChild(p2);

    let callback = debounce(() => {
      this.getStatisticsInfo(this.selectedStatistic, div)
    }, 700)
    div.appendChild(this.getCommonSelectContent('selectedStatistic', callback));

    const buttonGroup2 = makeElement('div', ['text_button']);
    if (binSize !== 'cellbin') {
      const cluster_layer = this.viewer.layerManager.managedLayers.filter((item: any) => (item.name.includes('cluster') || item.genefile === allToolsButton.genelistFile) && item.visible)[0];
      const gene_or_protein = cluster_layer.genefile.toLocaleLowerCase().includes('metabon') ? i18n.metabon_type : cluster_layer.genefile.toLocaleLowerCase().includes('protein') ? i18n.protein_type : i18n.gene_type;
      buttonGroup2.innerHTML = `
          <span class="lasso_info" data-checked="true">${i18n.lassoPanelInfo}</span><span class="lasso_gene" data-checked="false">${gene_or_protein}</span>
        `;
    } else {
      buttonGroup2.innerHTML = `
          <span class="lasso_info" data-checked="true">${i18n.lassoPanelInfo}</span><span class="lasso_cell" data-checked="false">${i18n.lassoPanelCell}</span>
        `;
    }
    div.appendChild(buttonGroup2);

    const subDiv = makeElement('div', ['analysisConfig']);
    if (binSize !== 'cellbin') {
      subDiv.innerHTML = `
          <div class="lasso_info_content">
            ${type === 'no_request' ? domContent.first : ''}
          </div>
          <div class="lasso_gene_content">
            ${type === 'no_request' ? domContent.second : ''}
          </div>
        `;
    } else {
      subDiv.innerHTML = `
          <div class="lasso_info_content">
            ${type === 'no_request' ? domContent.first : ''}
          </div>
          <div class="lasso_cell_content">
            ${type === 'no_request' ? domContent.second : ''}
          </div>
        `;
    }
    div.appendChild(subDiv)
    return div;
  }

  // 获取第三个弹框内容
  async getThirdInfoContent() {
    const div = makeElement('div', ['lasso__container'], {});
    const p = makeElement('p', [], {}, i18n.lassoPanelSelectlasso);
    div.appendChild(p);
    div.appendChild(this.getCommonSelectContent('selectedLasso'));
    div.appendChild(await this.getLassoBinsizeList());
    const footer = makeElement('div', ['lasso__footer']);
    const cancelBtn = makeElement('input', ['lasso_run_cancel'], {
      'type': 'button',
      'value': i18n.cancel
    });
    const submitBtn = makeElement('button', ['lasso_run_submit', 'async_submit_btn_loading'], { type: 'button', style: 'display: flex' },
      `<i class="submit_btn_el-icon-loading"><svg t="1687856555440" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1917" width="14" height="14"><path d="M511.882596 287.998081h-0.361244a31.998984 31.998984 0 0 1-31.659415-31.977309v-0.361244c0-0.104761 0.115598-11.722364 0.115598-63.658399V96.000564a31.998984 31.998984 0 1 1 64.001581 0V192.001129c0 52.586273-0.111986 63.88237-0.119211 64.337537a32.002596 32.002596 0 0 1-31.977309 31.659415zM511.998194 959.99842a31.998984 31.998984 0 0 1-31.998984-31.998984v-96.379871c0-51.610915-0.111986-63.174332-0.115598-63.286318s0-0.242033 0-0.361243a31.998984 31.998984 0 0 1 63.997968-0.314283c0 0.455167 0.11921 11.711527 0.11921 64.034093v96.307622a31.998984 31.998984 0 0 1-32.002596 31.998984zM330.899406 363.021212a31.897836 31.897836 0 0 1-22.866739-9.612699c-0.075861-0.075861-8.207461-8.370021-44.931515-45.094076L195.198137 240.429485a31.998984 31.998984 0 0 1 45.256635-45.253022L308.336112 263.057803c37.182834 37.182834 45.090463 45.253022 45.41197 45.578141A31.998984 31.998984 0 0 1 330.899406 363.021212zM806.137421 838.11473a31.901448 31.901448 0 0 1-22.628318-9.374279L715.624151 760.859111c-36.724054-36.724054-45.018214-44.859267-45.097687-44.93874a31.998984 31.998984 0 0 1 44.77618-45.729864c0.32512 0.317895 8.395308 8.229136 45.578142 45.411969l67.88134 67.88134a31.998984 31.998984 0 0 1-22.624705 54.630914zM224.000113 838.11473a31.901448 31.901448 0 0 0 22.628317-9.374279l67.88134-67.88134c36.724054-36.724054 45.021826-44.859267 45.097688-44.93874a31.998984 31.998984 0 0 0-44.776181-45.729864c-0.32512 0.317895-8.395308 8.229136-45.578142 45.411969l-67.88134 67.884953a31.998984 31.998984 0 0 0 22.628318 54.627301zM255.948523 544.058589h-0.361244c-0.104761 0-11.722364-0.115598-63.658399-0.115598H95.942765a31.998984 31.998984 0 1 1 0-64.00158h95.996952c52.586273 0 63.88237 0.111986 64.337538 0.11921a31.998984 31.998984 0 0 1 31.659414 31.97731v0.361244a32.002596 32.002596 0 0 1-31.988146 31.659414zM767.939492 544.058589a32.002596 32.002596 0 0 1-31.995372-31.666639v-0.361244a31.998984 31.998984 0 0 1 31.659415-31.970085c0.455167 0 11.754876-0.11921 64.34115-0.11921h96.000564a31.998984 31.998984 0 0 1 0 64.00158H831.944685c-51.936034 0-63.553638 0.111986-63.665624 0.115598h-0.335957zM692.999446 363.0176a31.998984 31.998984 0 0 1-22.863126-54.381656c0.317895-0.32512 8.229136-8.395308 45.41197-45.578141l67.88134-67.884953A31.998984 31.998984 0 1 1 828.693489 240.429485l-67.892177 67.88134c-31.020013 31.023625-41.644196 41.759794-44.241539 44.393262l-0.697201 0.722488a31.908673 31.908673 0 0 1-22.863126 9.591025z" fill="#ffffff" p-id="1918"></path></svg></i>
    ${i18n.if_submit}`);
    footer.appendChild(cancelBtn);
    footer.appendChild(submitBtn);
    div.appendChild(footer);
    return div;
  }

  // 公共函数, 用来获取选择框内容
  getCommonSelectContent(type: string, callback?: any) {
    const seleDiv = makeElement('div', ['select_area']);
    let subContent: any;
    if (type == 'selectedStatistic' || type == 'selectedLasso') {
      subContent = this.getSelectContent(this.labelNameArr, this[type].slice(0, this[type].length - 1).split(','), type, callback);
    } else {
      subContent = this.getSelectContent(this.binsizeArr, this[type].slice(0, this[type].length - 1).split(','), type, callback);
    }
    const button = new SelectView(null, {
      classes: ['lasso_select_area_view', type],
      defaultValue: this[type],
      backgroundScheme: 'dark',
      defaultTitle: this[type],
      childElement: subContent
    });
    button.element.addEventListener('click', () => {
      if (button.element.classList.contains('lasso_disabled')) return
      button.element.getAttribute('data-checked') === 'true' ? button.element.appendChild(subContent) : button.element.removeChild(subContent);
    });
    seleDiv.appendChild(button.element);
    return seleDiv;
  }

  async getLassoBinsizeList() {
    const seleDiv = makeElement('div', ['select_area'], { 'style': 'padding: 1rem 1.5rem 1rem' });
    const seleTitle = makeElement('div', ['item_title'], { 'style': 'font-weight: 600;margin-bottom: 0.5rem' }, i18n.lassoPanelSelectBin);
    const iniselectbin = this.viewer.binSize.value as string;
    const binlist = local_href_param.flag === 'tool' ? (await get_binlist_group()).bin_list : allToolsButton.bin_list as string[];
    const subContent = getBinSizeList(binlist, iniselectbin);
    selectBin = iniselectbin + ',';
    const button = new SelectView(null, {
      classes: ['lasso-binsize-view', 'mutil-select-binsize'],
      defaultValue: this.viewer.binSize.value as string,
      backgroundScheme: 'dark',
      // enableTitle: 'Show binsize panel',
      // disableTitle: 'Hide binsize panel',
      childElement: subContent
    });
    button.element.addEventListener('click', () => {
      if (button.element.classList.contains('lasso_disabled')) return
      button.element.getAttribute('data-checked') === 'true' ? button.element.appendChild(subContent) : button.element.removeChild(subContent);
    });
    seleDiv.appendChild(seleTitle);
    seleDiv.appendChild(button.element);
    const dom = document.getElementsByClassName('neuroglancer-rendered-data-panel')[0];
    button.registerEventListener(dom, 'click', () => {
      if (button) {
        button.close();
      }
    })
    return seleDiv
  }

  getLassoSelctContent() {
    if (this.allPathArr.length) {
      const ul = makeElement('ul', ['lasso_select']);
      this.allPathArr.forEach((item: any, index: number) => {
        let li = makeElement('li');
        li.dataset.id = String(index);
        li.dataset.checked = `${index == this.selectedPathIndex.value}`;
        li.innerHTML = `
            <input class="perfix-input" placeholder="${i18n.lassoPanelInputLabel}, ${i18n.lassoPanelForexample} Label1" value="${item.name}" readonly>
            <i class="label_edit">${svg_edit}</i>
            <i class="lasso_delete">${svg_delete}</i>
          `;
        ul.appendChild(li);
      })
      return ul;
    }
    return false;
  }

  // 提交lasso任务
  async LassoSubmitEvent(): Promise<void> {
    document.getElementsByClassName("lasso_run_submit")[0].classList.add('submit_btn_loading')
    // 传参数据
    const curr_layer = this.viewer.layerManager.managedLayers.filter((item) => (item.heatmap && item.visible) || (item.name.includes('cluster') && item.visible))[0];
    const export_bin = replaceAll(selectBin.substring(0, selectBin.length - 1), 'bin', '');
    let obj: any = {
      curr_bin: binSize.substring(3),
      points: {},
      center: Object.values(this.viewer.position.value),
      scale: this.viewer.crossSectionScale.value,
      sn: curr_layer.genesn,                           //  sn
      sample_id: curr_layer.genesn || local_href_param.sn,
      task_id: curr_layer.taskid,
      export_bin: export_bin,
      projectId: allToolsButton.projectId             //  项目名
    };
    // 数据处理
    let selectedLasso = this.selectedLasso.slice(0, this.selectedLasso.length - 1).split(',');
    this.allPathArr.forEach((item: any) => {
      if (selectedLasso.includes(item.name)) {
        // 和boundsize做一次交集操作
        let solutionPaths: any[] = this.cprExecute(item.points[0].arr, boundSizePath, ClipperLib.ClipType.ctIntersection);
        solutionPaths.forEach((path: any) => {
          path.forEach((point: { X: number, Y: number }, index: number) => {
            path[index] = [point.X, point.Y];
          })
        })
        obj.points[item.name] = solutionPaths;
      }
    });
    let task_lasso_req = async (): Promise<any> => {
      return await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/task/lasso`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(obj),
      }, responseJson);
    };
    let task_lasso_res = await task_lasso_req();
    if (task_lasso_res.code === 0) {
      new message(i18n.registrationPanelFilePath + task_lasso_res.data.path, 'success');
      let geojson = '';
      geojson = await this.data_warehouse(obj);
      document.getElementsByClassName("lasso_run_submit")[0].classList.remove('submit_btn_loading')
      await this.run_workflow(curr_layer, obj, task_lasso_res.data.path, geojson)
    } else {
      new message(i18n.asyncfail + task_lasso_res.msg, 'error');
    }
  }
  async run_workflow(curr_layer: any, obj: any, geojson: string, analysisPath?: string) {
    const details = {
      data: this.allPathArr,
      center: Object.values(this.viewer.position.value),
      scale: this.viewer.crossSectionScale.value,
    }
    let save_data: any = {};
    save_data.center = Object.values(this.viewer.position.value);
    save_data.scale = this.viewer.crossSectionScale.value;
    save_data.type = '2';
    save_data.num = '10';
    save_data.label = Object.keys(obj.points).join('_');
    save_data.projectId = allToolsButton.projectId;
    save_data.details = JSON.stringify(details);
    await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/operate_status/record_save`, {
      method: "post",
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify(save_data)
    }, responseJson)
    // 代谢数据lasso只入仓不走workflow
    if ((allToolsButton.genelistName as string).toLocaleLowerCase().includes('metabon')) return;
    const binsize = selectBin.substring(0, selectBin.length - 1).split(',').map((item: string) => item !== 'cellbin' ? item.replace('bin', '') : item).sort();
    const heat_layer = this.viewer.layerManager.managedLayers.filter((item) => (item.heatmap && item.visible))[0];
    let position = this.viewer.layerManager.managedLayers.indexOf(heat_layer);
    let cluster_layer: any;
    if (position !== -1) {
      cluster_layer = this.viewer.layerManager.managedLayers.filter((item, index) => item.name.includes('cluster') && (index > position));
    } else {
      cluster_layer = this.viewer.layerManager.managedLayers.filter((item) => item.name.includes('cluster') && item.visible);
    }
    const lasso_group_bin = await get_binlist_group('list');
    const workflow_params = await getWorkflowParam('lasso', heat_layer?.filename);
    workflow_params.bgef = workflow_params.bgef || lasso_group_bin.bgef_path;
    workflow_params.cgef = workflow_params.cgef || lasso_group_bin.cgef_path;
    console.log(workflow_params)
    const bgef = heat_layer?.menupath || workflow_params.bgef;
    const cgef = cluster_layer[0]?.menupath || workflow_params.cgef;
    let gef_cell_file_arr = bgef && cgef ? [bgef, cgef] : [];
    let cell_file_arr = cluster_layer[0]?.menupath ? [cgef] : [];
    let gef_file_arr = bgef ? [bgef] : [];
    let register_lasso_open_dialog: any = {}
    const sampleId = local_href_param.flag !== 'tool' ? workflow_params.sampleId || '' : curr_layer.genesn
    register_lasso_open_dialog['lasso'] = {
      src: 'SteroMap',
      type: 'params',
      value: {
        SN: sampleId,
        visGEF: binsize.includes('cellbin') && binsize.length > 1 ? gef_cell_file_arr : binsize.includes('cellbin') && binsize.length === 1 ? cell_file_arr : gef_file_arr,                      //  gef文件路径
        geojson: geojson,
        BinSize: binsize.includes('cellbin') && binsize.length > 1 ? [binsize.slice(0, binsize.length - 1), ['cellbin']] : [binsize]
      },
      originTaskId: local_href_param.flag === 'tool' ? curr_layer.taskid : local_href_param.DataID,
      sampleId: sampleId
    }
    if (viewer.binSize.value === 'cellbin') {
      let workflow_params = await getWorkflowParam(undefined, undefined, cluster_layer[0].taskid)
      if (!workflow_params.cellbinH5AD) {
        workflow_params = await getWorkflowParam('lasso', heat_layer?.filename);
      }
      register_lasso_open_dialog.lasso_markergene = {
        src: 'SteroMapV3',
        type: 'params',
        value: {
          SampleID: sampleId,
          mapfile: analysisPath,
          h5file: workflow_params.cellbinH5AD || '',
          globalanalysis: Boolean(Object.keys(obj.points).length < 2)
        },
        originTaskId: local_href_param.flag === 'tool' ? curr_layer.taskid : local_href_param.DataID,
        sampleId: sampleId
      }
    }
    this.viewer.workflowManualtoolsDialog = new registerLassoOpenDialog('lasso', register_lasso_open_dialog)
  }

  async data_warehouse(select_arr_obj: any) {
    let geojson = '';
    if (viewer.binSize.value === 'cellbin') {
      const filename = `${local_href_param.DataID}.${getData()}.lasso.json`;
      const warehouse_param_data: any = {
        label: [],
        x: [],
        y: []
      }
      const user_selected_label = Object.keys(select_arr_obj.points);
      let tmp_lasso_markergene_param = JSON.parse(JSON.stringify(this.lasso_markergene_param.all_jihe));
      for (let item in tmp_lasso_markergene_param) {
        if (!user_selected_label.includes(item)) {
          delete tmp_lasso_markergene_param[item]
        }
      }
      for (let i in tmp_lasso_markergene_param) {
        warehouse_param_data.label = warehouse_param_data.label.concat(tmp_lasso_markergene_param[i].label);
        warehouse_param_data.x = warehouse_param_data.x.concat(tmp_lasso_markergene_param[i].x);
        warehouse_param_data.y = warehouse_param_data.y.concat(tmp_lasso_markergene_param[i].y);
      }
      const data_warehouse_param = {
        project_id: local_href_param.projectId,
        filename: filename,
        path: '/Files/ManualData/StereoMap/Lasso/',
        data: warehouse_param_data,
        sample_id: select_arr_obj.sample_id
      }
      // data_warehouse: 入仓
      let req = async (): Promise<any> => {
        return await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/data_warehouse`, {
          method: 'post',
          body: JSON.stringify(data_warehouse_param),
          headers: { "Content-Type": "application/json" }
        }, responseJson);
      };
      let res = await req();
      if (res.code !== 0) {
        new message(i18n.asyncfail + res.msg, 'error');
        return '';
      } else if (res.code === 0) {
        geojson = '/Files/ManualData/StereoMap/Lasso/' + filename;
        return geojson
        // new message(i18n.registrationPanelFilePath + geojson + filename, 'success');
      }
    }
    return '';
  }

  // 转换数字为带单位的数字
  convertNum(num: any) {
    if (typeof num === 'string') {
      num = Number(num);
    }
    if (num > 1000000000) {
      return Number((num / 1000000000).toFixed(2)) + 'G'
    } else if (num > 1000000) {
      return Number((num / 1000000).toFixed(2)) + 'M'
    } else if (num > 1000) {
      return Number((num / 1000).toFixed(2)) + 'K'
    } else {
      return Number(num.toFixed(2));
    }
  }

  // 数字带千分位符，保留2位小数
  formatNumber(num: number) {
    num = +num;
    const thousandSeparator = ','; // 千分位符，可以根据需求更改
    const numStr = num.toFixed(2); // 保留两位小数
    const parts = numStr.split('.'); // 将整数部分和小数部分分开
    let intPart = parts[0];
    let decimalPart = parts[1];

    // 给整数部分添加千分位符
    const regex = /(\d)(?=(\d{3})+$)/g;
    intPart = intPart.replace(regex, `$1${thousandSeparator}`);

    let val;
    if (decimalPart !== '00') {
      val = `${intPart}.${decimalPart}`;
    } else {
      val = intPart;
    }

    return val;
  }

  // 简点操作
  simplify(points: Array<any>, tolerance = 1) {
    if (points.length < 3) {
      return points;
    }
    // 计算最远点和其位置
    let maxDistance = 0;
    let index = 0;
    // 结束索引
    const end = points.length - 1;
    for (let i = 1; i < end; i++) {
      const distance = this.pointLineDistance(points[i], points[0], points[end]);
      if (distance > maxDistance) {
        maxDistance = distance;
        index = i;
      }
    }
    // 如果大于公差，递归处理左右两部分
    if (maxDistance > tolerance) {
      const left = points.slice(0, index + 1);
      const right = points.slice(index);
      const leftResult: Array<any> = this.simplify(left, tolerance);
      const rightResult: Array<any> = this.simplify(right, tolerance);
      return [...leftResult.slice(0, -1), ...rightResult]; // 去掉重复的点
    } else {
      // 否则返回起点和终点
      return [points[0], points[end]];
    }
  }

  // 求点到直线的距离
  pointLineDistance(point: { X: number, Y: number }, start: { X: number, Y: number }, end: {
    X: number,
    Y: number
  }) {
    return Math.abs((end.Y - start.Y) * point.X - (end.X - start.X) * point.Y + end.X * start.Y - end.Y * start.X) / Math.sqrt(Math.pow(end.Y - start.Y, 2) + Math.pow(end.X - start.X, 2));
  }

  // 求点到线段的距离
  getDist(x: number, y: number, xa: number, ya: number, xb: number, yb: number) {
    const A = x - xa;
    const B = xb - xa;
    const C = y - ya;
    const D = yb - ya;
    const dot = A * B + C * D;
    const len_sq = B * B + D * D;
    let param = -1;
    if (len_sq !== 0) {
      param = dot / len_sq;
    }
    let xx, yy;
    if (param < 0) {
      xx = xa;
      yy = ya;
    } else if (param > 1) {
      xx = xb;
      yy = yb;
    } else {
      xx = xa + param * B;
      yy = ya + param * D;
    }
    const dx = x - xx;
    const dy = y - yy;
    return Math.sqrt(dx * dx + dy * dy);
  }

  // 判断轨迹是否顺时针绘制
  isClockwise(pts: any[]) {
    let S = 0;
    for (let i = 0; i < pts.length; i++) {
      let j = (i + 1) % pts.length;
      S += (pts[j].X - pts[i].X) * (pts[j].Y + pts[i].Y);
    }
    return S < 0;
  }

  // 绘制单个特征点
  drawPoint(x: number, y: number) {
    this.ctx!.beginPath();
    this.ctx!.arc(x, y, POINT_RADIUS, 0, 2 * Math.PI);
    this.ctx!.fillStyle = 'yellow';
    this.ctx!.fill();
  }

  // 根据轨迹来绘制特征点
  drawPointWithArr(arr: any[]) {
    arr.forEach((path: any[]) => {
      path.forEach((itemChild: { X: number, Y: number }) => {
        const screenPoint = this.project([itemChild.X, itemChild.Y])
        this.drawPoint(screenPoint[0], screenPoint[1]);
      })
    })
  }

  // 判断轨迹选中逻辑
  pathSelect(e: any, selectedIndex: number) {
    let index: number = -1;
    if (selectedIndex >= 0) {
      index = selectedIndex;
    } else {
      let data: any = this.cloneCtx?.getImageData(e.clientX, e.clientY, 1, 1).data;
      let color = `#${numToHex(data[0])}${numToHex(data[1])}${numToHex(data[2])}`;
      for (let i = 0; i < this.colorArr.length; i++) {
        if (this.colorArr[i] === color) {
          index = i;
          break;
        }
      }
    }
    if (index >= 0) {
      // 如果相等代表取消选中
      if (index === this.selectedPathIndex.value) {
        this.allPathArr[this.selectedPathIndex.value].selected = false;
        this.selectedPathIndex.value = -1;
        this.draw();
      } else {
        // 大于等于0代表之前有选中，所以要先取消
        if (this.selectedPathIndex.value >= 0) {
          this.allPathArr[this.selectedPathIndex.value].selected = false;
        }
        this.selectedPathIndex.value = index;
        this.allPathArr[this.selectedPathIndex.value].selected = true;
        this.draw();
      }
    } else {
      // 点击空白区域代表取消选中
      if (this.selectedPathIndex.value >= 0) {
        this.allPathArr[this.selectedPathIndex.value].selected = false;
        this.selectedPathIndex.value = -1;
        this.draw();
      }
    }
  }

  // 查找特征点
  findSelectedPoint(x: number, y: number) {
    console.log(x, y)
    let arr = this.allPathArr[this.selectedPathIndex.value].points[0].arr;
    for (let i1 = 0; i1 < arr.length; i1++) {
      for (let i2 = 0; i2 < arr[i1].length; i2++) {

        const projectPoint = this.project([arr[i1][i2].X, arr[i1][i2].Y])
        const dx = projectPoint[0] - x;
        const dy = projectPoint[1] - y;
        if (dx * dx + dy * dy <= POINT_RADIUS * POINT_RADIUS) {
          this.selectedNgPoint = arr[i1][i2];
          return arr[i1][i2];
        }
      }
    }
    return null;
  }

  // 添加新的特征点
  addPoint(x: number, y: number) {
    let mindist = Number.MAX_SAFE_INTEGER;
    let parentIndex = 0;
    let index = 0;
    let arr = this.allPathArr[this.selectedPathIndex.value].points[0].arr;
    for (let i1 = 0; i1 < arr.length; i1++) {
      for (let i2 = 0; i2 < arr[i1].length; i2++) {
        const a = arr[i1][i2];
        const b = i2 + 1 === arr[i1].length ? arr[i1][0] : arr[i1][i2 + 1];
        const dist = this.getDist(x, y, a.X, a.Y, b.X, b.Y);
        if (dist < mindist) {
          mindist = dist;
          parentIndex = i1;
          index = i2;
        }
      }
    }
    arr[parentIndex].splice(index + 1, 0, { X: x, Y: y });
    this.draw();
  }

  // 初始化
  initCanvas() {
    this.allPathArr = [{
      name: 'Label1',
      points: [{
        type: 'yes',
        arr: [],
      }],
      selected: false
    }];
    this.selectedPathIndex.value = -1;
    this.colorArr = [randomColor()];
  }

  // 获取不重名的lable名
  getUniqueName() {
    while (true) {
      for (let i = 1; i < Number.MAX_SAFE_INTEGER; i++) {
        let labelName = `Label${i}`;
        if (!labelNameSet.has(labelName)) {
          return labelName
        }
      }
    }
  }

  // 取消选中函数
  cancelSelected() {
    // 先判断当前是否选中轨迹, 如果选中, 则取消选中
    if (this.selectedPathIndex.value >= 0) {
      this.allPathArr[this.selectedPathIndex.value].selected = false;
      this.selectedPathIndex.value = -1;
    }
  }

  // Enter和NumpadEnter操作逻辑
  async enterOperate(type?: string) {
    if (this.btn.getAttribute('data-checked') === 'false') {
      return
    }
    if (!this.allPathArr[0].points[0].arr.length) {
      new message(i18n.lassoPanelFirst, 'info');
      return;
    }
    this.allPathArr.forEach((item: any) => {
      let arr = JSON.parse(JSON.stringify(item.points[0].arr));
      arr.forEach((path: any) => {
        path.forEach((itemChild: any, index: number) => {
          path[index] = this.unProject(itemChild);
        })
      })
    })
    const all_lunkuo_poinst: any = [];
    this.allPathArr.forEach((path: any) => {
      path.points[0].arr.forEach((point: any) => {
        let arr: number[] = [];
        point.forEach((item: any) => {
          arr.push(item.X, item.Y);
        })
        all_lunkuo_poinst.push(arr);
      })
    });
    await this.get_many_window_lunkuo(all_lunkuo_poinst)
    // 重新获取label名集合和selectedStatistic
    this.labelNameArr.length = 0
    this.selectedStatistic = '';
    this.allPathArr.forEach((item: any, index: number) => {
      this.labelNameArr.push(item.name);
      labelNameSet.add(item.name);
      // 如果有选中轨迹，则展示选中轨迹统计信息，否则展示所有轨迹统计信息
      if (this.selectedPathIndex.value >= 0) {
        if (index === this.selectedPathIndex.value) {
          this.selectedStatistic += `${item.name},`;
        }
      } else {
        this.selectedStatistic += `${item.name},`;
      }
    })
    // 打开弹框
    let secondMessagesContent = this.getSecondInfoContent(type);
    // 24是ui图上1920尺寸下弹框距离定位元素的距离
    let secondMessages = new ConfigIndependDialog(geneSelectDom, secondMessagesContent, {
      position: 'bottom',
      unique: true,
      className: 'second_info_container',
      offsetCol: htmlFontSize / 16 * 24
    });
    if (!(type === 'no_request' && domContent.first && domContent.second)) {
      domContent.first = domContent.second = '';
      // 获取统计信息
      this.getStatisticsInfo(this.selectedStatistic, secondMessagesContent);
    }
    let lasso_select = secondMessagesContent.getElementsByClassName("lasso_select")[0];
    setTimeout(() => {
      console.log(lasso_select.scrollHeight);
      lasso_select.scrollTop = lasso_select!.scrollHeight;
    }, 0);
    // 给每个label名input框绑定事件
    let inputArr = secondMessagesContent.querySelectorAll('.lasso_select li input');
    for (let i = 0; i < inputArr.length; i++) {
      let currentInput: any = inputArr[i];
      currentInput.onblur = () => {
        // 获取labelName的数组副本，并将对应index位置置为''，防止影响判断逻辑
        let labelNameArrClone = JSON.parse(JSON.stringify(this.labelNameArr));
        labelNameArrClone[i] = '';
        const old_label_name = this.allPathArr[i].name;
        let label_name = currentInput.value.trim();
        if (!label_name) {
          new message(i18n.lassoPanelInputLabel, 'warning');
          currentInput.focus();
          return;
        } else if (!/^[A-Za-z0-9_]+$/.test(label_name)) {
          new message(i18n.lassoPanelPatter, 'warning');
          currentInput.focus();
          return;
        } else if (labelNameArrClone.includes(label_name)) {
          // 检测到轨迹命名重名
          new SwitchV2Info(this.viewer, i18n.lassoPanelDuplicate, () => {
            let index = labelNameArrClone.indexOf(label_name);
            // 先取消选中
            this.cancelSelected();
            // 合并轨迹
            this.mergePath(i, index);
            // 已经合并完了，根据index确定selectedPathIndex
            if (index > i) {
              this.selectedPathIndex.value = index - 1;
            } else {
              this.selectedPathIndex.value = index;
            }
            this.allPathArr[this.selectedPathIndex.value].selected = true;
            this.draw();
            this.enterOperate();
          }, () => {
            currentInput.value = this.labelNameArr[i];
            currentInput.readOnly = true;
          });
          return;
        }
        if (this.allPathArr[i].name !== label_name) {
          this.allPathArr[i].name = label_name;
          domContent.first = secondMessagesContent.querySelector('.lasso_info_content')!.innerHTML;
          domContent.second = (binSize === 'cellbin' ? secondMessagesContent.querySelector('.lasso_cell_content') : secondMessagesContent.querySelector('.lasso_gene_content'))?.innerHTML as string;
          console.log(domContent)
          this.enterOperate('no_request');
        }
        for (let i in this.lasso_markergene_param.all_jihe) {
          // 更改集合名称
          if ((i === old_label_name) && (i !== label_name)) {
            this.lasso_markergene_param.all_jihe[label_name] = this.lasso_markergene_param.all_jihe[i];
            this.lasso_markergene_param.all_jihe[label_name].label = this.lasso_markergene_param.all_jihe[label_name].label.map(() => label_name);
            delete this.lasso_markergene_param.all_jihe[i]
          }
        }
        currentInput.readOnly = true;
        console.log(label_name, this.lasso_markergene_param.all_jihe)
      }
    }
    // 绑定其他按钮操作逻辑
    secondMessagesContent.addEventListener('click', async (e: any) => {
      if (e.target!.className === 'perfix-input') {
        // disabled状态下才能选中或者取消选中
        if (e.target.readOnly) {
          this.pathSelect(null, +e.target.parentNode.dataset.id);
          const this_li_checked = e.target.parentNode.dataset.checked;
          // 将每个li的data-checked设为false;
          let liArr = secondMessagesContent.querySelectorAll('.lasso_select li');
          for (let i = 0; i < liArr.length; i++) {
            (<any>liArr[i]).dataset.checked = 'false';
          }
          e.target.parentNode.dataset.checked = this_li_checked === 'true' ? 'true' : 'false';
        }
      } else if (e.target!.className === 'label_edit') {
        if (e.target.parentNode.dataset.checked === 'false') return;
        // 修改label名
        let input = e.target.parentNode.firstElementChild;
        input.readOnly = false;
        input.focus();
      } else if (e.target!.className === 'lasso_save') {
        if (e.target.parentNode.dataset.checked === 'false') return;
        // 保存lasso
        // 先判断label名是否合规
        let label_name = e.target.parentElement.firstElementChild.value.trim();
        if (!/^[A-Za-z0-9_]+$/.test(label_name)) return;
        // 取得要保存轨迹的index
        let index = +e.target.parentNode.dataset.id;
        // 和boundsize做一次交集操作
        let solutionPaths: any[] = this.cprExecute(this.allPathArr[index].points[0].arr, boundSizePath, ClipperLib.ClipType.ctIntersection)
        solutionPaths.forEach((path: any) => {
          path.forEach((point: { X: number, Y: number }, index: number) => {
            path[index] = [point.X, point.Y];
          })
        })
        // 传参数据
        let obj: any = {
          curr_bin: binSize.substring(3),
          points: {},
          center: Object.values(this.viewer.position.value),
          scale: this.viewer.crossSectionScale.value,
        };
        obj.points[label_name] = solutionPaths;
        let req = async (): Promise<any> => {
          return await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/task/lasso`, {
            method: 'post',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8'
            },
            body: JSON.stringify(obj),
          }, responseJson);
        };
        let res = await req();
        if (res.code === 0) {
          new message(i18n.registrationPanelFilePath + res.data.file_path, 'success');
        } else {
          new message(i18n.asyncfail + res.msg, 'error');
        }
      } else if (e.target!.className === 'lasso_delete') {
        if (e.target.parentNode.dataset.checked === 'false') return;
        // 先取消选中
        this.cancelSelected();
        // 删除对应lasso
        let index = +e.target.parentNode.dataset.id;
        delete this.lasso_markergene_param.all_jihe[this.allPathArr[index].name]
        this.colorArr.splice(index, 1)
        this.allPathArr.splice(index, 1);
        if (!this.allPathArr.length) {
          this.initCanvas();
        }
        this.draw();
        // 关闭并重新打开弹框
        this.enterOperate();
      } else if (e.target!.className === 'lasso_add') {
        // 先取消选中
        this.cancelSelected();
        this.draw();
        // 新增lasso
        while (true) {
          let color = randomColor();
          if (!this.colorArr.includes(color)) {
            this.colorArr.push(color);
            break;
          }
        }
        this.allPathArr.push({
          name: this.getUniqueName(),
          points: [
            {
              type: 'yes',
              arr: [],
            }
          ],
          selected: false
        });
        // 关闭弹框
        secondMessages.close();
        // 新增lasso时继续第一个弹框提示, 24是ui图上1920尺寸下弹框距离定位元素的距离
        new ConfigIndependDialog(geneSelectDom, this.getFirstInfoContent(), {
          position: 'bottom',
          unique: true,
          className: 'first_info_container',
          offsetCol: htmlFontSize / 16 * 24
        });
      } else if (e.target!.className === 'lasso_run') {
        // 投递任务
        //  if (this.selectedPathIndex.value >= 0) {
        //    this.selectedLasso = this.allPathArr[this.selectedPathIndex.value].name + ',';
        //  } else {
        this.selectedLasso = '';
        this.allPathArr.forEach((item: any) => {
          this.selectedLasso += `${item.name},`;
        })
        //  }
        // 取消选中状态
        this.cancelSelected();
        this.draw();
        // 打开弹框
        let thirdMessagesContent = await this.getThirdInfoContent();
        // 用于控制弹框情况下不能lasso
        this.canDraw = false;
        // 24是ui图上1920尺寸下弹框距离定位元素的距离
        let thirdMessages = new ConfigIndependDialog(geneSelectDom, thirdMessagesContent, {
          position: 'bottom',
          unique: true,
          className: 'third_info_container',
          offsetCol: htmlFontSize / 16 * 24
        });
        // 弹框的X按钮, 继续本轮绘制
        thirdMessages.buttonClose.addEventListener('click', () => {
          this.canDraw = true;
        })
        // 绑定其他按钮操作逻辑
        thirdMessagesContent.addEventListener('click', async (e: any) => {
          if (e.target!.className === 'lasso_run_cancel') {
            // 回到第二个弹框
            this.enterOperate();
            this.canDraw = true;
          } else if (e.target!.className === 'lasso_run_submit async_submit_btn_loading') {
            // 套索提交
            this.LassoSubmitEvent();
            disableStatus(false, undefined, false);
          }
        })
      } else if (e.target!.className === 'lasso_info' || e.target!.className === 'lasso_gene' || e.target!.className === 'lasso_cell') {
        // 查看info信息
        // 当前已是选中状态，则不做任何处理
        if (e.target.dataset.checked === 'true') {
          return;
        } else {
          // 将每个span的data-checked设为false
          let spanArr = secondMessagesContent.querySelectorAll('.text_button span');
          for (let i = 0; i < spanArr.length; i++) {
            (<any>spanArr[i]).dataset.checked = 'false';
            (<any>secondMessagesContent.querySelector(`.${spanArr[i].className}_content`)).style.display = "none";
          }
          ;
          // 再将当前点击元素的data-checked设为true
          e.target.dataset.checked = 'true';
          (<any>secondMessagesContent.querySelector(`.${e.target.className}_content`)).style.display = "block";
        }
      } else if (e.target!.className === 'can_click_li') {
        // 统计信息中li标签点击事件
        let val = e.target.parentNode.dataset.checked;
        e.target.parentNode.dataset.checked = val === 'true' ? 'false' : 'true';
      }
    })
  }

  // 合并轨迹
  mergePath(i1: number, i2: number) {
    // 合并canvas坐标系坐标
    let solutionPaths2: any[] = this.cprExecute(this.allPathArr[i2].points[0].arr, this.allPathArr[i1].points[0].arr, ClipperLib.ClipType.ctUnion, 'paths');
    this.allPathArr[i2].points.length = 1;
    this.allPathArr[i2].points[0].arr = solutionPaths2;
    // 删除合并了的轨迹以及颜色
    this.allPathArr.splice(i1, 1);
    this.colorArr.splice(i1, 1);
  }

  // 获取统计信息
  async getStatisticsInfo(type: string, content: any) {
    // 去掉结尾','并分割
    let arr = type.slice(0, type.length - 1).split(',');
    let tempMap = {};
    this.allPathArr.forEach((item: any) => {
      tempMap[item.name] = item;
    })
    // 获取ng坐标系坐标的并集
    this.cpr.Clear();
    let solutionPaths: any[] = [];
    if (arr.length >= 2) {
      for (let i = 0; i < arr.length; i++) {
        if (i === 0) {
          this.cpr.AddPaths(tempMap[arr[i]].points[0].arr, ClipperLib.PolyType.ptSubject, true);
        } else {
          this.cpr.AddPaths(tempMap[arr[i]].points[0].arr, ClipperLib.PolyType.ptClip, true);
        }
      }
      this.cpr.Execute(ClipperLib.ClipType.ctUnion, solutionPaths, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
    } else {
      solutionPaths = JSON.parse(JSON.stringify(tempMap[arr[0]].points[0].arr));
    }
    // 和boundsize做一次交集操作
    let solutionPaths2: any[] = this.cprExecute(solutionPaths, boundSizePath, ClipperLib.ClipType.ctIntersection);
    // 处理数据格式
    solutionPaths2.forEach((path: any[], index: number) => {
      let arr: number[] = [];
      path.forEach((point: any) => {
        arr.push(point.X, point.Y);
      })
      solutionPaths2[index] = arr;
    })
    // 获取统计信息
    await this.getAnalysisData(solutionPaths2, content);
  }

  async getAnalysisData(coor: any, content: any) {
    console.log(allToolsButton)
    const cluster_file = this.viewer.layerManager.managedLayers.filter((item: any) => item.name.includes('cluster') && item.visible)[0]?.genefile;
    let req = async (url: string): Promise<any> => {
      return await cancellableFetchSpecialOk(undefined, url, {
        method: 'post',
        body: JSON.stringify({
          curr_bin: binSize.substring(3),
          point_list: coor,
          file: this.viewer.binSize.value === 'cellbin' ? cluster_file : allToolsButton.genelistFile
        }),
        headers: { "Content-Type": "application/json" }
      }, responseJson);
    }

    let element = content.querySelector('.lasso_info_content')!;
    const url1 = binSize === 'cellbin' ? `${local_host_SN_flag}/cellbin_lasso_statistics` : `${local_host_SN_flag}/lasso_data`;
    element.innerHTML = `
     <div class="el-loading-spinner">
      <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
      </svg>
    </div>
     `;
    let res = await req(url1);
    if (res.code === 0) {
      let str = '';
      const cluster_layer = this.viewer.layerManager.managedLayers.filter((item: any) => (item.name.includes('cluster') || item.genefile === allToolsButton.genelistFile) && item.visible)[0];
      const gene_or_protein = cluster_layer.genefile.toLocaleLowerCase().includes('metabon') ? i18n.lassoPanelMeanMetabolite : cluster_layer.genefile.toLocaleLowerCase().includes('protein') ? i18n.lassoPanelMeanProtein : i18n.lassoPanelMeanGene;
      if (binSize !== 'cellbin') {
        str = `
            <p><span>${i18n.lassoPanelTotalArea}</span> <span>${this.convertNum(res.data.area_total)} μm²</span></p>
            <p><span>${(allToolsButton.genelistName as string).includes('metabon') ? i18n.total_intensity : i18n.lassoPanelTotalMIDCount}</span> <span>${this.convertNum(res.data.mid_total)}</span></p>
            <p><span>${(allToolsButton.genelistName as string).includes('metabon') ? i18n.lassoPanelMeanIntensity : i18n.lassoPanelMeanMID}</span> <span>${this.convertNum(res.data.mid_mean)}/${this.convertNum(res.data.mid_median)}</span></p>
            <p><span>${gene_or_protein}</span> <span>${this.convertNum(res.data.gene_mean)}/${this.convertNum(res.data.gene_median)}</span></p>
          `;
      } else {
        str = `
            <p><span>${i18n.lassoPanelTotalArea}</span> <span>${this.convertNum(res.data.total_area)} μm²</span></p>
            <p><span>${i18n.lassoPanelCellCount}</span> <span>${this.convertNum(res.data.cell_count)}</span></p>
            <p><span>${i18n.lassoPanelMeanArea}</span> <span>${this.convertNum(res.data.average_area)}/${this.convertNum(res.data.median_area)} μm²</span></p>
            <p><span>${i18n.lassoPanelMeanMID}</span> <span>${this.convertNum(res.data.average_exp_count)}/${this.convertNum(res.data.median_exp_count)}</span></p>
            <p><span>${i18n.lassoPanelMeanDNB}</span> <span>${this.convertNum(res.data.average_dnb_count)}/${this.convertNum(res.data.median_dnb_count)}</span></p>
            <p><span>${gene_or_protein}</span> <span>${this.convertNum(res.data.average_gene_count)}/${this.convertNum(res.data.median_gene_count)}</span></p>
          `;
      }
      if (element) element.innerHTML = str;
    } else if (res.code === 20000) {
      if (element) element.innerHTML = `<p>${i18n.nodata}</p>`;
    } else {
      if (element) element.innerHTML = '';
      new message(i18n.asyncfail + res.msg, 'error');
    }

    let element2 = binSize === 'cellbin' ? content.querySelector('.lasso_cell_content') : content.querySelector('.lasso_gene_content');
    element2.innerHTML = `
     <div class="el-loading-spinner">
      <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
      </svg>
    </div>
     `;
    const url2 = binSize === 'cellbin' ? `${local_host_SN_flag}/lasso_statistics_cell` : `${local_host_SN_flag}/lasso_statistics_gene`;
    let res2 = await req(url2);
    console.log(this.selectedStatistic, this.allPathArr)
    let all_label = this.selectedStatistic;
    // let res2 = {code: 20000, data: 'none'}
    let lasso_markergene_param_flag = false;
    if (res2.code === 0) {
      all_label = all_label.substring(0, all_label.length - 1);
      if (all_label.split(',').length === 1) {
        lasso_markergene_param_flag = true;
      }
      let str = '';
      if (binSize !== 'cellbin') {
        str += `<ul data-checked="true"><li class="can_click_li"><span class="tl">${(allToolsButton.genelistName as string).includes('metabon') ? i18n.metabon : i18n.lassoPanelGene}</span><span class="tr">${(allToolsButton.genelistName as string).includes('metabon') ? i18n.intensity : i18n.midCount}</span></li></ul>`;
        str += '<ul>'
        res2.data.detail.forEach((item: any) => {
          str += `<li><span class="tl">${item.gene_name}</span><span class="tr">${this.formatNumber(item.mid_cnt)}</span></li>`;
        })
        str += '</ul>';
        str += `<ul><li><span class="tl">${i18n.lassoPanelTotal}</span><span class="tr">${this.formatNumber(res2.data.total)}</span></li></ul>`;
      } else {
        let clusterIdArr: number[] = [];
        res2.data.abstract.forEach((item: any) => {
          item.cell_id = `(${item.cell_id})`;
          clusterIdArr.push(item.cluster_id);
        })
        if (lasso_markergene_param_flag) {
          this.lasso_markergene_param.all_jihe[all_label] = {
            label: [],
            x: [],
            y: []
          }
          res2.data.detail.forEach((item: any) => {
            this.lasso_markergene_param.all_jihe[all_label].label.push(all_label);
            this.lasso_markergene_param.all_jihe[all_label].x.push(item.x);
            this.lasso_markergene_param.all_jihe[all_label].y.push(item.y);
          })
        }
        res2.data.detail = res2.data.detail.concat(res2.data.abstract);
        let allInfoArr = []
        for (let i = 0; i < clusterIdArr.length; i++) {
          let tempArr: any[] = [];
          res2.data.detail.forEach((item: any) => {
            if (item.cluster_id === clusterIdArr[i]) {
              tempArr.push(item);
            }
          })
          allInfoArr.push(tempArr);
        }
        str += `<ul><li><span class="tl">${i18n.lassoPanelCluster}</span><span class="tl">${i18n.lassoPanelCellID}</span><span class="tr">${i18n.lassoPanelMeanMID}</span><span class="tr">${i18n.lassoPanelArea}(μm²)</span></li></ul>`
        allInfoArr.forEach((item: any) => {
          str += '<ul data-checked="true">';
          item.forEach((itemChild: any, index: number) => {
            if (index === 0 || (index === item.length - 1)) {
              str += `
                  <li class="can_click_li">
                    <span class="tl">${itemChild.cluster_id}</span>
                    <span class="tl">${itemChild.cell_id}</span>
                    <span class="tr">${this.formatNumber(itemChild.mid_cnt)}</span>
                    <span class="tr">${this.formatNumber(itemChild.area)}</span>
                  </li>
                `
            } else {
              str += `
                  <li>
                    <span class="tl">${itemChild.cluster_id}</span>
                    <span class="tl">${itemChild.cell_id}</span>
                    <span class="tr">${this.formatNumber(itemChild.mid_cnt)}</span>
                    <span class="tr">${this.formatNumber(itemChild.area)}</span>
                  </li>
                `
            }
          });
          str += '</ul>'
        })
      }
      if (element2) element2.innerHTML = str;
    } else if (res2.code === 20000) {
      if (element2) element2.innerHTML = `<p>${i18n.nodata}</p>`;
    } else {
      if (element2) element2.innerHTML = '';
      new message(i18n.asyncfail + res.msg, 'error');
    }
  }

  // 获取选择框内容
  getSelectContent(list: string[], hasList: string[], type: string, callback: any) {
    const binsizeContiner = makeElement('div');
    const ul = makeElement('ul', ['el-select-dropdown__list']);
    list.forEach((item: string) => {
      const li = makeElement('li', ['el-select-dropdown_item'], {});
      const span = makeElement('span', [], {
        title: `${item}`, style: `
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;`
      }, `${item}`)
      const cb = makeElement('input', ['ng-common-checkbox']) as HTMLInputElement;
      cb.type = 'checkbox';
      li.appendChild(cb);
      li.appendChild(span);
      ul.appendChild(li);
      cb.checked = hasList.includes(item);
      li.dataset.checked = hasList.includes(item) ? 'true' : 'false';
      li.addEventListener('click', () => {
        let oldVal = this[type];
        const flag = li.getAttribute('data-checked') === 'false';
        this.change_select_bin(flag, item, type);
        if (!this.isLastSelected) {
          if (flag) {
            cb.checked = true;
            li.dataset.checked = 'true';
          } else {
            cb.checked = false;
            li.dataset.checked = 'false';
          }
        }
        if (oldVal !== this[type] && callback) {
          let lassoInfoContent = document.querySelector('.lasso__container .analysisConfig .lasso_info_content')!;
          lassoInfoContent.innerHTML = `
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg>
              </div>
            `;
          if (binSize !== 'cellbin') {
            let lassoGeneContent = document.querySelector('.lasso__container .analysisConfig .lasso_gene_content')!;
            lassoGeneContent.innerHTML = `
                <div class="el-loading-spinner">
                  <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                  </svg>
                </div>
              `;
          } else {
            let lassoCellContent = document.querySelector('.lasso__container .analysisConfig .lasso_cell_content')!;
            lassoCellContent.innerHTML = `
                <div class="el-loading-spinner">
                  <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                  </svg>
                </div>
              `;
          }
          callback();
        }
      });
    })
    binsizeContiner.appendChild(ul);
    return binsizeContiner
  }

  change_select_bin(flag: boolean, item: string, type: string) {
    this.isLastSelected = false;
    if (flag) {
      this[type] += `${item},`;
    } else {
      const lastBin = this[type].split(',');
      if (lastBin.length < 3 && lastBin[0] === item) {
        new message(i18n.lassoPanelLeastone, 'warning');
        this.isLastSelected = true;
        return
      }
      this[type] = this[type].replace(`${item},`, '');
    }
    let ele: any = document.getElementsByClassName(type)[0].getElementsByClassName('selecte-text')[0];
    ele.innerHTML = this[type];
    ele.title = this[type];
  }

  cprExecute(subjectPath: any, clipPath: any, clipType: any, pathType = 'path') {
    let solutionPaths: any[] = [];
    this.cpr.Clear();
    this.cpr.AddPaths(subjectPath, ClipperLib.PolyType.ptSubject, true);
    if (pathType === 'path') {
      // path类型
      this.cpr.AddPath(clipPath, ClipperLib.PolyType.ptClip, true);
    } else {
      // paths类型
      this.cpr.AddPaths(clipPath, ClipperLib.PolyType.ptClip, true);
    }
    this.cpr.Execute(clipType, solutionPaths, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
    return solutionPaths;
  }

  async get_many_window_lunkuo(coor: any) {
    if (local_href_param.visible || this.viewer.binSize.value === 'cellbin') return
    let req1 = async (): Promise<any> => {
      const url = `${local_host_SN_flag}/lasso/coordinate`;
      return await cancellableFetchSpecialOk(undefined, url, {
        method: 'post',
        body: JSON.stringify({
          curr_bin: binSize.substring(3),
          point_list: coor,
          file: allToolsButton.genelistFile
        }),
        headers: { "Content-Type": "application/json" }
      }, responseJson);
    }
    let res1 = await req1();
    if (res1.code === 0) {
      console.log(res1);
      if (!local_href_param.visible) {
        const obj = {
          href: '',
          value: res1.data
        }
        if (dbStorageMoreWindow) {
          await dbStorageMoreWindow.update('layerName', { name: 'value', data: obj });
        }
        localStorage.setItem('layerName', new Date().toLocaleString());
      }
    }
  }
  dispose() {
    super.dispose();
    if (!this.isDuplicate) {
      this.exitLasso();
      viewer.lassoTool = undefined;
    }
  }
}

function getBinSizeList(list: string[], initbin: string) {
  const binsizeContiner = makeElement('div', ['binsize-container'], {});
  const ul = makeElement('ul', ['el-select-dropdown__list']);
  list.forEach((item: string) => {
    const li = makeElement('li', ['el-select-dropdown_item'], {});
    const span = makeElement('span', [`binlist-${item}-cb`], {}, `${item}`)
    const cb = makeElement('input', ['ng-common-checkbox', `binlist-${item}-cb`]) as HTMLInputElement;
    cb.type = 'checkbox';
    li.appendChild(cb);
    li.appendChild(span);
    ul.appendChild(li);
    cb.checked = item === initbin;
    li.dataset.checked = item === initbin ? 'true' : 'false';
    span.addEventListener('click', () => {
      const flag = li.getAttribute('data-checked') === 'false';
      cb.checked = isLastBin ? isLastBin : flag;
    });
    cb.addEventListener('change', () => {
      const flag = li.getAttribute('data-checked') === 'false';
      cb.checked = isLastBin ? isLastBin : !flag
    })
    li.addEventListener('click', () => {
      const flag = li.getAttribute('data-checked') === 'false';
      change_select_bin(flag, item);
      if (!isLastBin) {
        if (flag) {
          cb.checked = true;
          li.dataset.checked = 'true';
        } else {
          cb.checked = false;
          li.dataset.checked = 'false';
        }
      }
    });
  })
  binsizeContiner.appendChild(ul);
  return binsizeContiner
}

function change_select_bin(flag: boolean, item: string) {
  isLastBin = false;
  if (flag) {
    selectBin += `${item},`;
  } else {
    const lastBin = selectBin.split(',');
    if (lastBin.length < 3 && lastBin[0] === item) {
      new message(i18n.lassoPanelLeastone, 'warning');
      isLastBin = true;
      return
    }
    selectBin = selectBin.replace(`${item},`, '');
  }
  let ele: any = document.getElementsByClassName('mutil-select-binsize')[0].getElementsByClassName('selecte-text')[0];
  ele.innerHTML = selectBin;
  ele.title = selectBin;
}

function replaceAll(str: string, find: string, replace: string) {
  return str.replace(new RegExp(find, 'g'), replace)
}

let lasso_bin: any = {
  bin_list: [],
  bgef_path: '',
  cgef_path: []
};
async function get_binlist_group(str?: string) {
  if (str) {
    return lasso_bin;
  } else {
    const layer = viewer.layerManager.managedLayers.filter((item: any) => (item.heatmap && item.visible) || (item.name.includes('cluster') && item.visible))
    console.log(layer[0].taskid)
    const taskId = layer[0].taskid
    if (taskId) {
      let req = async (): Promise<any> => {
        return await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/get_group_bin/${layer[0].taskid}/${layer[0].filename}`, {}, responseJson);
      };
      const res = await req();
      lasso_bin = res.data
    } else {
      const gef_binlist = (layer[0].layer?.dataSources[0].loadState as LoadedLayerDataSource).dataSource.subsources[0].subsource.annotation?.metadata.binlist
      lasso_bin.bin_list = viewer.binSize.value === 'cellbin' ? ['cellbin'] : gef_binlist
    }
    return lasso_bin;
  }
}
